(function(){'use strict';
function normalise(raw){
  var value=String(raw||'').trim();
  if(!value)return value;
  var out=value
    .replace(/\bballpen\b/gi,'ball pen')
    .replace(/\brefil(?:s)?\b/gi,function(m){return /s$/i.test(m)?'refills':'refill'})
    .replace(/\bopen[ -]?cap(?:ped)?(?:\s+pen)?\b/gi,'openable pen')
    .replace(/\bcapped\s+pen\b/gi,'openable pen')
    .replace(/\bcap\s+pen\b/gi,'openable pen')
    .replace(/\broller\s*ball(?:\s+pen)?\b/gi,'roller pen')
    .replace(/\brollerball(?:\s+pen)?\b/gi,'roller pen')
    .replace(/\bcross[ -]?refill\b/gi,'cross type refill')
    .replace(/\bcross[ -]?type\b/gi,'cross type')
    .replace(/\bmobile\s+touch(?:\s+pen)?\b/gi,'stylus pen')
    .replace(/\btouch\s+pen\b/gi,'stylus pen')
    .replace(/\bblueink\b/gi,'blue ink')
    .replace(/\bblackink\b/gi,'black ink')
    .replace(/\bredink\b/gi,'red ink')
    .replace(/\bgoldclip\b/gi,'gold clip')
    .replace(/\bsilverclip\b/gi,'silver clip')
    .replace(/\s+/g,' ')
    .trim();
  return out;
}
function isSearchForm(form){
  if(!form||String(form.method||'get').toLowerCase()!=='get')return false;
  var action=form.getAttribute('action')||'';
  return action.indexOf('/search')>-1||form.querySelector('input[name="q"]')!==null;
}
function bind(){
  document.addEventListener('submit',function(event){
    var form=event.target;
    if(!isSearchForm(form))return;
    var input=form.querySelector('input[name="q"]');
    if(!input)return;
    var next=normalise(input.value);
    if(next&&next!==input.value.trim())input.value=next;
  },true);

  try{
    if(window.location.pathname.indexOf('/search')===0){
      var url=new URL(window.location.href);
      var current=url.searchParams.get('q')||'';
      var next=normalise(current);
      if(current&&next&&next!==current){
        url.searchParams.set('q',next);
        url.searchParams.delete('page');
        window.location.replace(url.toString());
      }
    }
  }catch(e){}
}
window.BPBSearchTerminology={normalise:normalise};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind);else bind();
})();